import { createApp } from 'vue';

export default {
    name : 'siblings',

    init()
    {
        const el = document.getElementById("siblings-app");
        if (el) {
            this.initSiblings();
        }
    },

    initSiblings()
    {
        createApp({

            data() {
                return {
                    sibling : ''
                }
            },

            created: function()
            {
                // console.log('siblings ready!!');
            },

            methods :
            {
                redirectToSibling()
                {
                    if (this.sibling.length) {
                        window.location.href = this.sibling;
                    }
                }
            }
        }).mount('#siblings-app'); // end of vue
    }
}